import React from "react";
import classes from "../styles/Analysis.module.css"

type Props = {
  onChange(data: string[][]): void;
};

const CSVSelector = ({ onChange }: Props) => {
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      try {
        const file = e.target.files[0];

        // 1. create url from the file
        const fileUrl = URL.createObjectURL(file);

        // 2. use fetch API to read the file
        const response = await fetch(fileUrl);

        // 3. get the text from the response
        //const text = await response.text();
        const text = await response.text();
        //const text = textRaw.replace(";", ",");
        //console.log (text);

        // 4. split the text by newline
        const lines = text.split("\n");

        // 5. map through all the lines and split each line by comma.
        const _data = lines.map((line) => line.split(";"));

        // 6. call the onChange event
        onChange(_data);
      } catch (error) {
        console.error(error);
      }
    }
  };
  return (<div className={classes.containerContent}><input type="file" accept=".csv" onChange={handleFileChange} /></div>);
};

export default CSVSelector;
